export enum BusinessContactWaiverStatus {
    UNKNOWN,
    SIGNED,
    VOIDED
}